import { useTranslation } from "react-i18next";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../../../../useAppTheme";
import Box from "../../../../Box";

type Props = {
	remainingSeconds: number;
	playOnce?: boolean;
	isVideo?: boolean;
};

export const PrepCountdownBanner = ({
	remainingSeconds,
	playOnce,
	isVideo,
}: Props) => {
	const theme = useAppTheme();
	const { t } = useTranslation();

	const key = isVideo
		? playOnce
			? "session.prepBanner.videoStartsInPlayOnce"
			: "session.prepBanner.videoStartsIn"
		: playOnce
			? "session.prepBanner.audioStartsInPlayOnce"
			: "session.prepBanner.audioStartsIn";
	const message = t(key, { seconds: remainingSeconds });

	return (
		<Box
			accessibilityRole="alert"
			paddingHorizontal={16}
			paddingVertical={12}
			borderRadius={theme.roundness * 2}
			backgroundColor={theme.colors.surface}
		>
			<Text
				variant="bodyMedium"
				style={{ color: theme.colors.onSurfaceVariant, fontWeight: "500" }}
			>
				{message}
			</Text>
		</Box>
	);
};

export default PrepCountdownBanner;
